import { createContext, useContext, useState, useEffect } from "react";
import { apiFetchAdmin } from '../../hooks/apiFetch';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useAdmin } from "./AdminContext";
import { useLangUrl } from "../../utilities/useLangUrl";

// import Cookies from 'js-cookie';

const AdminModiratorContext = createContext();

export function AdminModiratorProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [modirators, setModirators] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const { profile } = useAdmin();
    const langUrl = useLangUrl();

    const isSuperAdmin = profile?.data?.role === "superAdmin";

    useEffect(() => {
        if (!Cookies.get('adminToken')) {
            navigate("/admin/adminLogin")
        }
        if (!isSuperAdmin) {
            setModirators(null);
            setLoading(false);
            return;
        }
        async function fetchModirators() {
            try {
                const data = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/users/moderators?page=${currentPage}&limit=11`);
                setModirators(data);
            } catch (err) {
                setModirators(null);
            } finally {
                setLoading(false);
            }
        }
        fetchModirators();
    }, [navigate, currentPage, isSuperAdmin, langUrl]);


    return (
        <AdminModiratorContext.Provider value={{ loading, setLoading, modirators, setModirators, currentPage, setCurrentPage }}>
            {children}
        </AdminModiratorContext.Provider>
    );
}

export function useAdminModirator() {
    return useContext(AdminModiratorContext);
}